export function getDeviceId() {
  let id = localStorage.getItem("fridge_device_id");
  if (!id) {
    id = (crypto.randomUUID && crypto.randomUUID()) || `dev-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem("fridge_device_id", id);
  }
  return id;
}

const PENDING_KEY = "fridge_pending_before";

export function savePendingBefore(data) {
  localStorage.setItem(PENDING_KEY, JSON.stringify(data));
}

export function getPendingBefore() {
  const raw = localStorage.getItem(PENDING_KEY);
  try {
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function clearPendingBefore() {
  localStorage.removeItem(PENDING_KEY);
}

// --- Share streak (device-local) ---
export function getStreak() {
  try {
    return parseInt(localStorage.getItem("fridge_cards_shared") || "0", 10);
  } catch {
    return 0;
  }
}

export function bumpStreak() {
  try {
    const n = getStreak() + 1;
    localStorage.setItem("fridge_cards_shared", String(n));
    return n;
  } catch {
    return getStreak() + 1;
  }
}

// --- Display name for group fridges ---
export function getDisplayName() {
  return localStorage.getItem("fridge_name") || "";
}

export function setDisplayName(name) {
  localStorage.setItem("fridge_name", name);
}
